/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const FetchCitiesQuery = gql`
  query FetchCitiesQuery($postalCode: String) {
    fetchCities_simulation_customer_grantees(postalCode: $postalCode) {
      cities {
 value  
label  
}
    }
  }
`;

export default FetchCitiesQuery;
